import React from 'react';
import { Outlet, NavLink } from 'react-router-dom';

function AdminLayout() {
    return (
        <div className="admin-wrapper">
            <aside className="admin-sidebar">
                <div className="sidebar-header">
                    <img src="/logo.png" alt="Evomotor" style={{ height: 30, width: 'auto' }} />
                    <span>Admin Blog</span>
                </div>
                <nav className="sidebar-nav">
                    <NavLink to="/admin/blog" end className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        <span className="nav-icon">📝</span>
                        Articoli
                    </NavLink>
                    <NavLink to="/admin/blog/create" className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}>
                        <span className="nav-icon">➕</span>
                        Nuovo Articolo
                    </NavLink>
                    <a href="/blog" target="_blank" rel="noopener noreferrer" className="nav-item">
                        <span className="nav-icon">👁️</span>
                        Vedi Blog
                    </a>
                </nav>
            </aside>

            <main className="admin-main">
                <Outlet />
            </main>
        </div>
    );
}

export default AdminLayout;
